import { useModal } from 'context/Modal/Context';
import { MODAL_NAME } from 'context/Modal/MODAL_NAME';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import useDeleteOrder from '../../hooks/useDeleteOrder';
import usePrintingInfoModals from '../../hooks/usePrintingInfoModals';
import { usePrintingOrders } from 'hooks/queries/printOndemandeProducts/usePrintOnDemandeProduct';

const usePrintingDetail = () => {
  const { query, push } = useRouter();
  const deleteOrder = useDeleteOrder();
  const { openModal } = useModal();
  const { openOnboardingModal, openPricingGridModal } = usePrintingInfoModals();

  const currentId = query.slug?.[1] || '';
  const { data: { data } = {} } = usePrintingOrders({ id: currentId });
  const openEditModal = () => {
    openModal(MODAL_NAME.CREATE_PRINTING_ORDER, {
      id: currentId,
      orderLang: data?.language || undefined,
      orderName: data?.name || '',
    });
  };

  const handleDeletePrintingOrder = async () => {
    const result = await new Promise((resolve) => {
      openModal(MODAL_NAME.CMS_MODAL, {
        cmsModalName: 'printing-order-delete',
        onSubmit: () => resolve(true),
      });
    });

    if (result) {
      await deleteOrder.mutateAsync(currentId);
      await push(query.slug?.[0] || '');
    }
  };

  const openCreatePrintingPage = () => {
    openModal(MODAL_NAME.CREATE_PRINTING_PAGE, {
      printingOrder: currentId,
    });
  };

  const onFinalizeOrder = () => {
    if (data?.full) {
      push(`/printing/${currentId}/checkout`);
    } else {
      openModal(MODAL_NAME.CMS_MODAL, {
        cmsModalName: 'printing-order-warning-finish-pack',
      });
    }
  };

  const openManagerUser = () => {
    openModal(MODAL_NAME.MANAGE_POD_ENTRANT, {});
  };

  useEffect(() => {
    if (data?.printingPages?.length === 0) {
      openCreatePrintingPage();
    }
  }, [data]);

  return {
    data,
    openEditModal,
    handleDeletePrintingOrder,
    openPricingGridModal,
    currentId,
    openCreatePrintingPage,
    openOnboardingModal,
    onFinalizeOrder,
    openManagerUser,
  };
};

export default usePrintingDetail;
